import type { QuestionDTO, QuestionQueryDTO } from './types'
import { request } from '@/utils'

export default {
  getTree: () => request.get('/exam/category/tree'),

  addCategory: (data: any) => request.post('/exam/category/add', data),

  updateCategory: (data: any) => request.post('/exam/category/update', data),

  delCategory: (id: string) => request.delete(`/exam/category/del/${id}`),

  pageList: (data: any) => request.post('/exam/question/pageList', data.body),

  add: (data: QuestionDTO) => request.post('/exam/question/add', data),

  update: (data: QuestionDTO) => request.post('/exam/question/update', data),

  // 审核通过后题目才会进入后端题库缓存，支持单条和批量审核。
  audit: (ids: string[]) => request.post('/exam/question/audit', { ids }),

  del: (id: string) => request.delete(`/exam/question/del/${id}`),

  detail: (id: string) => request.get(`/exam/question/${id}/detail`),

  importExcel: (data: FormData) =>
    request.post('/exam/question/importExcel', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  // 导出只需要当前筛选条件，分页字段可省略以导出全部匹配题目。
  exportExcel: (data: Partial<QuestionQueryDTO>) =>
    request.post('/exam/question/exportExcel', data, {
      responseType: 'blob',
    }),

  downloadTemplate: () =>
    request.get('/exam/question/template', {
      responseType: 'blob',
    }),

  duplicateCheck: (threshold: number, categoryId?: string) =>
    request.post('/exam/question/duplicateCheck', null, {
      params: { threshold, categoryId },
    }),

  batchDelete: (ids: string[]) => request.post('/exam/question/batchDelete', ids),

  getStatistics: () => request.get('/exam/question/statistics'),
}
